import {
    useEffect,
    useState,
} from 'react';

// FNP-815: the search input (SimpleTableBatchAction, inside RecordsTable) and the
// list hook that does the filtering live in DIFFERENT components. A plain
// useState here would give each caller its OWN copy of the keyword, so typing in
// the box would never reach the filter and search would silently do nothing.
// The keyword therefore lives in a module-scoped store that every caller
// subscribes to. Do not replace this with a local useState.
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

export const useTestDefinitionsSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        keywordListeners.add(listener);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifyKeywordChange(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
